import {
  ApiBlobGetRequest,
  ApiGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - Upgrade Repair',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Upgrade Repair',
        href: '/adm/opr/report/repeat-repair-eor',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_eor_repeat_detail',
    sortDesc: true,
    fields: [
      {
        key: 'date_repeat',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: false,
      },
      {
        key: 'code_eor',
        label: 'EOR',
        sortable: false,
      },
      {
        key: 'status_repeat',
        label: 'Status',
        sortable: false,
      },
    ],
    detail: false,
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
      id_consignee: '',
      consignee_code: '',
      consignee_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportRepeatRepair(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getRepeatRepairEOR({ commit, state }) {
    commit('reportRepeatRepair', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      start_date: data.form.date ? data.form.date[0] : '',
      end_date: data.form.date ? data.form.date[1] : '',
    };

    let result = await ApiGetRequest(`opr/report/repeat-repair-eor`, params);
    commit('reportRepeatRepair', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return true;
  },

  async getExportRepeatRepairEOR({ commit, state }) {
    commit('reportRepeatRepair', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      start_date: data.form.date ? data.form.date[0] : '',
      end_date: data.form.date ? data.form.date[1] : '',
    };

    let result = await ApiBlobGetRequest(
      `opr/report/repeat-repair-eor`,
      params
    );
    commit('reportRepeatRepair', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_container_eor_repair.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
